<div class="w-100">
  <h1 class="head1">MQTT Settings</h1>
</div>
<div class="row">
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm p-3">
      <h5 class="font-15p mb-3">MQTT Details</h5>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3"
          >Host Name /IP<span class="text-danger">*</span></label
        >
        <div class="col-md-9">
          <input type="text" class="form-control" [(ngModel)]="host" />
        </div>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3"
          >Port<span class="text-danger">*</span></label
        >
        <div class="col-md-9">
          <input type="text" class="form-control" [(ngModel)]="port" />
        </div>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3">CA Certificate</label>
        <div class="col-md-9">
          <div class="d-flex align-items-start">
            <input
              type="text"
              class="form-control flex-grow-1 me-2"
              [(ngModel)]="caCertFileName"
              readonly
            />
            <div class="custom-input-file">
              <label
                for="caFileInput"
                class="file-input-label btn btn-primary-sa"
                >Browse</label
              >
              <input
                type="file"
                class="file-input"
                id="caFileInput"
                (change)="onFileSelected($event, 'caCert')"
              />
            </div>
            <button
              class="btn btn-primary-sa ms-2"
              (click)="clearFile('caCert')"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3">TLS Certificate</label>
        <div class="col-md-9">
          <div class="d-flex align-items-start">
            <input
              type="text"
              class="form-control flex-grow-1 me-2"
              [(ngModel)]="tlsCertFileName"
              readonly
            />
            <div class="custom-input-file">
              <label
                for="tlsFileInput"
                class="file-input-label btn btn-primary-sa"
                >Browse</label
              >
              <input
                type="file"
                class="file-input"
                id="tlsFileInput"
                (change)="onFileSelected($event, 'tlsCert')"
              />
            </div>
            <button
              class="btn btn-primary-sa ms-2"
              (click)="clearFile('tlsCert')"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3">TLS Key</label>
        <div class="col-md-9">
          <div class="d-flex align-items-start">
            <input
              type="text"
              class="form-control flex-grow-1 me-2"
              [(ngModel)]="tlsKeyFileName"
              readonly
            />
            <div class="custom-input-file">
              <label
                for="keyFileInput"
                class="file-input-label btn btn-primary-sa"
                >Browse</label
              >
              <input
                type="file"
                class="file-input"
                id="keyFileInput"
                (change)="onFileSelected($event, 'tlsKey')"
              />
            </div>
            <button
              class="btn btn-primary-sa ms-2"
              (click)="clearFile('tlsKey')"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3">&nbsp;</label>
        <div class="col-md-9 text-end">
          <button
            class="btn btn-secondary-sa me-2 mb-2"
            (click)="getSettings()"
          >
            Cancel
          </button>
          <button class="btn btn-primary-sa mb-2" (click)="saveSettings()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
